module.exports = "https://bin.bnbstatic.com/_next/static/images/world_map-2c18649c2cb47be549e281b28e5f6f72.svg";